module.exports = "<header class=\"secondary\"></header>\n<section class=\"mainless\">\n  <header>\n    <h1>Not Implemented</h1>\n    <p>There is nothing to see here... yet. Please check back later.</p>\n  </header>\n</section>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/not-implemented/not-implemented.component.html
// module id = 1667
// module chunks = 0